import { requestApi } from '../util/network'
// 获取手机验证码
export const getSmsCaptcha =
    (type, phone) =>
      requestApi(
        '/Connect/get_sms_captcha',
        'GET',
        {
          'type': type,
          'phone': phone
        }
      )
// 验证码检测
export const checkPictureCaptcha =
    (captcha) =>
      requestApi(
        '/Seccode/check',
        'POST',
        {
          'captcha': captcha
        }
      )
export const getWechatShare =
    (url) =>
        requestApi(
            '/index/getWechatShare',
            'POST',
            {
                'url': url
            }
        )
//浏览统计
export const getbuyerview =
    (member_id,url,stay_time,platform_type,store_id) =>
        requestApi(
            '/buyer/view',
            'POST',
            {
                'member_id': member_id,
                'url': url,
                'stay_time': stay_time,
                'platform_type':platform_type,
                'store_id':store_id,
            }
        )
//搜索分类统计
export const getbuyersearch =
    (search_cont,type,member_id,cate_id) =>
        requestApi(
            '/buyer/search',
            'POST',
            {
                'search_cont': search_cont,
                'type': type,
                'member_id': member_id,
                'cate_id': cate_id
                
            }
        )         